import { Icon, hero_icon_pause, hero_icon_plus, hero_icon_wink } from '../../../components/Icon/Icon';

type CmsWorkyInfoColumnProps = { heading: string; text: string; iconShape: 'pause' | 'plus' | 'wink' };
export const CmsWorkyInfoColumn = ({ heading, text, iconShape }: CmsWorkyInfoColumnProps): JSX.Element => {
	let icon;
	switch (iconShape) {
		case 'pause':
			icon = <Icon shape={hero_icon_pause} />;
			break;
		case 'plus':
			icon = <Icon shape={hero_icon_plus} />;
			break;
		case 'wink':
			icon = <Icon shape={hero_icon_wink} />;
			break;
	}
	return (
		<div className="info-column">
			<div className="icon">{icon}</div>
			<div className="text">
				<h2>{heading}</h2>
				<p>{text}</p>
			</div>
		</div>
	);
};
